import React from 'react';
import { PlayCircle, Target, Search, CheckCircle, FileText } from 'lucide-react';

export function HelpJobSearchWorkflow() {
  return (
    <section>
      <div className="flex items-center gap-2 mb-4">
        <PlayCircle className="w-5 h-5 text-emerald-500" />
        <h3 className="text-lg font-medium text-slate-900 dark:text-slate-100">Job Search Workflow</h3>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        <div className="flex gap-4 p-4 rounded-xl border border-indigo-100 dark:border-slate-800 bg-indigo-50/50 dark:bg-slate-900/50 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-1 h-full bg-indigo-500" />
          <div className="shrink-0 bg-white dark:bg-indigo-500/20 w-8 h-8 rounded-full flex items-center justify-center font-bold text-indigo-600 dark:text-indigo-400 shadow-sm border border-indigo-100 dark:border-transparent">1</div>
          <div>
            <h4 className="font-semibold text-sm text-slate-900 dark:text-slate-100 flex items-center gap-2">
              <Target className="w-4 h-4 text-indigo-500" /> Setup Profile
            </h4>
            <p className="text-sm text-slate-600 dark:text-slate-400 mt-1 pb-1">Define your target job title, location, and desired skills.</p>
          </div>
        </div>

        <div className="flex gap-4 p-4 rounded-xl border border-violet-100 dark:border-slate-800 bg-violet-50/50 dark:bg-slate-900/50 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-1 h-full bg-violet-500" />
          <div className="shrink-0 bg-white dark:bg-violet-500/20 w-8 h-8 rounded-full flex items-center justify-center font-bold text-violet-600 dark:text-violet-400 shadow-sm border border-violet-100 dark:border-transparent">2</div>
          <div>
            <h4 className="font-semibold text-sm text-slate-900 dark:text-slate-100 flex items-center gap-2">
              <Search className="w-4 h-4 text-violet-500" /> AI Search
            </h4>
            <p className="text-sm text-slate-600 dark:text-slate-400 mt-1 pb-1">Let the AI scour the web to find relevant job openings matching your profile.</p>
          </div>
        </div>

        <div className="flex gap-4 p-4 rounded-xl border border-emerald-100 dark:border-slate-800 bg-emerald-50/50 dark:bg-slate-900/50 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-1 h-full bg-emerald-500" />
          <div className="shrink-0 bg-white dark:bg-emerald-500/20 w-8 h-8 rounded-full flex items-center justify-center font-bold text-emerald-600 dark:text-emerald-400 shadow-sm border border-emerald-100 dark:border-transparent">3</div>
          <div>
            <h4 className="font-semibold text-sm text-slate-900 dark:text-slate-100 flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-emerald-500" /> Review Matches
            </h4>
            <p className="text-sm text-slate-600 dark:text-slate-400 mt-1 pb-1">Browse the results to find jobs that perfectly fit your constraints and track the missing ones.</p>
          </div>
        </div>

        <div className="flex gap-4 p-4 rounded-xl border border-blue-100 dark:border-slate-800 bg-blue-50/50 dark:bg-slate-900/50 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-1 h-full bg-blue-500" />
          <div className="shrink-0 bg-white dark:bg-blue-500/20 w-8 h-8 rounded-full flex items-center justify-center font-bold text-blue-600 dark:text-blue-400 shadow-sm border border-blue-100 dark:border-transparent">4</div>
          <div>
            <h4 className="font-semibold text-sm text-slate-900 dark:text-slate-100 flex items-center gap-2">
              <FileText className="w-4 h-4 text-blue-500" /> Import & Tailor
            </h4>
            <p className="text-sm text-slate-600 dark:text-slate-400 mt-1 pb-1">Found a winner? Import the job straight into a Resume workspace to start tailoring.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
